const DEFAULT_API_BASE = '/api';
const DEFAULT_REALTIME_BASE = '/api/realtime';

export function getApiBaseUrl(): string {
  return process.env.NX_API_BASE_URL ?? process.env.API_BASE_URL ?? DEFAULT_API_BASE;
}

export function getRealtimeBaseUrl(): string {
  return process.env.NX_REALTIME_BASE_URL ?? process.env.REALTIME_BASE_URL ?? DEFAULT_REALTIME_BASE;
}

export function isDev(): boolean {
  const nodeEnv = process.env.NODE_ENV;
  if (nodeEnv === 'production') {
    return false;
  }

  const browserLocation =
    typeof globalThis === 'object'
      ? (globalThis as typeof globalThis & { location?: { hostname?: string } }).location
      : undefined;

  if (browserLocation?.hostname) {
    const hostname = browserLocation.hostname.toLowerCase();
    const isLocalHost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '0.0.0.0' ||
      hostname.endsWith('.local');

    if (!isLocalHost) {
      return false;
    }
  }

  return true;
}
